<div class="capsule main">
  <span></span>
  @if (!loadingOerror()) {
    <div ngbAccordion>
      <div ngbAccordionItem="settingsItem" #settingsItem="ngbAccordionItem">
        <div ngbAccordionHeader>
          <button class="accordion-button">
            <div class="d-flex title justify-content-between align-items-center">
              <h2>{{ 'menu-settings' | translate }}</h2>
              <mat-form-field class="search-settings" appearance="outline">
                <input matInput type="text" [ngModel]="setsearch()" (ngModelChange)="setsearch.set($event); search($event); resetL()"
                  placeholder="{{ 'setting-search' | translate }}">
                @if (setsearch()) {
                  <button matSuffix matIconButton aria-label="Clear" (click)="setsearch.set(''); resetL()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
          </button>
        </div>
        <div ngbAccordionCollapse>
          <div class="d-flex flex-wrap">
            <div class="canevasList">
              <ul>
                @for (set of lSetting(); track set) {
                  <li class="d-flex flex-row justify-content-between align-items-center elem"
                    type="button" id="elem{{set.setting_name}}" (click)="settingSelected(set); scroolTo()">
                    <h3 class="text-capitalize">{{ set.setting_name }}</h3>
                    <div class="d-flex flex-row justify-content-around align-items-center icons">
                      @if (set.description) {
                        <div class="d-flex flex-row description dpresent justify-content-center align-items-center">
                          <p>{{ set.description }}</p>
                          <div class="d-flex justify-content-around">
                            <app-edit-settings-form [description]="true" (click)="$event.stopPropagation()"
                              [parameter]="set.setting_name" [vselected]="set.description"
                              (eventEdit)="editDescription($event, set.setting_name)">
                            </app-edit-settings-form>
                            <app-delete-form-settings [description]="true" (click)="$event.stopPropagation()"
                              [parameter]="set.setting_name" [vtodelete]="set.description"
                              (eventDelete)="deleteDescription($event, set.setting_name)">
                            </app-delete-form-settings>
                          </div>
                        </div>
                      }
                      @if (!set.description || set.description == '') {
                        <app-add-value-form-settings class="description" [description]="true" [onlyone]="true"
                          (click)="$event.stopPropagation()" [parameter]="set.setting_name"
                          (newValuesL)="addDescription($event, set.setting_name)">
                        </app-add-value-form-settings>
                      }
                      @if (typeofValue(set.setting_value) != 'string' && typeofValue(set.setting_value) != 'map') {
                        <app-add-value-form-settings
                          [dico]="false" [ltocompare]="getArray(set.setting_value)" [parameter]="set.setting_name"
                          (click)="$event.stopPropagation()"
                          (newValuesL)="addValues($event, set.setting_name)">
                        </app-add-value-form-settings>
                      } @else {
                        @if (typeofValue(set.setting_value) == 'map') {
                          <app-add-value-form-settings
                            [dico]="true" (click)="$event.stopPropagation()"
                            [ltocompare]="mapKeyToList(getMap(set.setting_value))" [parameter]="set.setting_name"
                            (newValuesM)="addValues($event, set.setting_name)">
                          </app-add-value-form-settings>
                        } @else {
                          @if (set.setting_value == '') {
                            <app-add-value-form-settings (click)="$event.stopPropagation()"
                              [dico]="false" [onlyone]="true" [parameter]="set.setting_name"
                              (newValuesL)="addValues($event, set.setting_name)">
                            </app-add-value-form-settings>
                          }
                        }
                      }
                    </div>
                    <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
                  </li>
                }
              </ul>
            </div>
            <div id="settingValue" hidden="hidden">
              @if (settingSelect()) {
                <div class="d-flex selectedSett flex-column justify-content-center align-items-center">
                  @if (typeofValue(settingSelect()!.setting_value) === 'string') {
                    @if (getString(settingSelect()!.setting_value) != '') {
                      <div>
                        <div class="string elem d-flex flex-row justify-content-between align-items-center">
                          <p>{{ getString(settingSelect()!.setting_value) }}</p>
                          <div class="actions d-flex justify-content-around">
                            <app-edit-settings-form
                              [parameter]="settingSelect()!.setting_name"
                              [vselected]="getString(settingSelect()!.setting_value)"
                              (eventEdit)="editValue($event, settingSelect()!.setting_name, getString(settingSelect()!.setting_value))">
                            </app-edit-settings-form>
                            <app-delete-form-settings [parameter]="settingSelect()!.setting_name"
                              [vtodelete]="getString(settingSelect()!.setting_value)"
                              (eventDelete)="deleteValue($event, settingSelect()!.setting_name)">
                            </app-delete-form-settings>
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="d-flex flex-row justify-content-around align-items-center novalue">
                        <img id="notfound" src="assets/images/Components/notfoundalone.svg">
                        <h3>{{ 'setting-no-value' | translate }}</h3>
                      </div>
                    }
                  } @else if (typeofValue(settingSelect()!.setting_value) === 'array') {
                    <div>
                      @if (getArray(settingSelect()!.setting_value).length > 0) {
                        @for (val of getArray(settingSelect()!.setting_value); track val) {
                          <div class="elem d-flex flex-row justify-content-between align-items-center">
                            <p>{{ val }}</p>
                            <div class="actions d-flex justify-content-around">
                              <app-edit-settings-form [parameter]="settingSelect()!.setting_name" [vselected]="val"
                                [ltocompare]="sliceValue(val, getArray(settingSelect()!.setting_value))"
                                (eventEdit)="editValue($event, settingSelect()!.setting_name, val)">
                              </app-edit-settings-form>
                              <app-delete-form-settings [parameter]="settingSelect()!.setting_name" [vtodelete]="val"
                                (eventDelete)="deleteValue($event, settingSelect()!.setting_name)">
                              </app-delete-form-settings>
                            </div>
                          </div>
                        }
                      } @else {
                        <div class="d-flex flex-row justify-content-around align-items-center novalue">
                          <img id="notfound" src="assets/images/Components/notfoundalone.svg">
                          <h3>{{ 'setting-no-value' | translate }}</h3>
                        </div>
                      }
                    </div>
                  } @else if (typeofValue(settingSelect()!.setting_value) === 'map') {
                    <div>
                      @if (getLengthOfMap(getMap(settingSelect()!.setting_value)) > 0) {
                        @for (item of getMap(settingSelect()!.setting_value) | keyvalue: originalOrder; track item) {
                          <div class="elem d-flex flex-row justify-content-between align-items-center">
                            <p>{{ item.key }} : <b>{{ item.value }}</b></p>
                            <div class="actions d-flex justify-content-around">
                              <app-edit-settings-form [dico]="true" [parameter]="settingSelect()!.setting_name" [key]="item.key"
                                [vselected]="item.value"
                                (eventEdit)="editValue($event, settingSelect()!.setting_name, item.key)">
                              </app-edit-settings-form>
                              <app-delete-form-settings [parameter]="settingSelect()!.setting_name" [key]="item.key"
                                [vtodelete]="item.value"
                                (eventDelete)="deleteValue($event, settingSelect()!.setting_name)">
                              </app-delete-form-settings>
                            </div>
                          </div>
                        }
                      } @else {
                        <div class="d-flex flex-row justify-content-around align-items-center novalue">
                          <img id="notfound" src="assets/images/Components/notfoundalone.svg">
                          <h3>{{ 'setting-no-value' | translate }}</h3>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @else {
    @if (loadingOerror()) {
      <app-loading-error [boolean]="true" [message]="'waiting-for-settings' | translate">
      </app-loading-error>
    } @else {
      @if (setsearch() != '' && setsearch() != undefined) {
        <app-loading-error [boolean]="false" [search]="('component-error-search-settings' | translate) + ' ' + setsearch()"
          [order]="'component-settings-search-order' | translate">
        </app-loading-error>
      }
    }
  }
</div>
<app-toast-component></app-toast-component>